import { Select, DatePicker } from 'antd';
import { KButton } from 'common/component/KButton';
import KPageHeader from 'common/component/KPageHeader';
import KProTip from 'common/component/KProTip';
import KSpinner from 'common/component/KSpinner';
import { month_type } from 'common/constants';
import { tableCustomStyles } from 'common/style/tableCustomStyle';
import React from 'react';
import DataTable from 'react-data-table-component';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import styled from 'styled-components';
import { useAttendance } from '../hooks/useAttendance';
import tableColumn from './user.table';
import { useGrade } from '../../routine/hooks/useGrade';
import { GradeModel } from 'data/grade/grade.model';

interface Props {}

const AttendanceView: React.FC<Props> = () => {
  const [selectedGrade, setSelectedGrade] = React.useState<string>('');
  const [selectedSection, setSelectedSection] = React.useState<string>('');
  const [selectedMonth, setSelectedMonth] = React.useState<string>('');
  const [selectedYear, setSelectedYear] = React.useState<string>('');
  const [isGetAttendanceIsClicked, setIsGetAttendanceIsClicked] = React.useState<boolean>(false);
  const attendance = useSelector((state: RootState) => state.attendance);
  const grade = useSelector((state: RootState) => state.grade);
  const [gradeData, setGradeData] = React.useState<GradeModel>({
    id: '',
    startTime: '',
    endTime: '',
    sections: [],
  });
  const { fetchGrade } = useGrade();
  const { fetchAttendance } = useAttendance();

  const handleGetAttendance = (): void => {
    fetchAttendance(selectedGrade, selectedSection, selectedMonth, selectedYear);
    setIsGetAttendanceIsClicked(true);
  };

  React.useEffect(() => {
    fetchGrade();
  }, []);
  return (
    <AttendanceViewWrapper>
      <KPageHeader title="Attendance" />
      <KProTip
        title="Page Hint"
        description="This page is for viewing and managing attendance of students & staffs"
      />
      <section className="section-wrapper">
        <section className="page-tabs">
          <Select
            defaultValue="Select Grade"
            className="grade-select-field"
            onSelect={(value) => {
              setSelectedGrade(value);
              setIsGetAttendanceIsClicked(false);
              grade.data.map((item) => {
                if (item.id === value) {
                  setGradeData(item);
                }
              });
            }}
          >
            {grade.data.map((item) => (
              <Select.Option key={`atten-class${item.id}`} value={item.id}>
                {item.id}
              </Select.Option>
            ))}
          </Select>
        </section>
        <section className="page-tabs">
          <Select
            defaultValue="Select Section"
            className="grade-select-field"
            onSelect={(val) => {
              setSelectedSection(val);
              setIsGetAttendanceIsClicked(false);
            }}
          >
            {gradeData.sections.map((section) => (
              <Select.Option key={`atten-class${section.id}`} value={section.id}>
                {section.id}
              </Select.Option>
            ))}
          </Select>
        </section>

        <section className="page-tabs">
          <Select
            defaultValue="Select Month"
            className="grade-select-field"
            onSelect={(val) => {
              setSelectedMonth(val);
              setIsGetAttendanceIsClicked(false);
            }}
          >
            {month_type.map((item) => (
              <Select.Option key={item.id} value={item.value}>
                {item.title}
              </Select.Option>
            ))}
          </Select>
        </section>
        <section className="page-tabs">
          <DatePicker
            picker="year"
            className="grade-select-field"
            onChange={(date, dateString) => setSelectedYear(dateString)}
          ></DatePicker>
        </section>

        <KButton onClick={handleGetAttendance}>Get Attendance</KButton>
      </section>

      {isGetAttendanceIsClicked && (
        <section className="page-table">
          {attendance.status === 'loading' && <KSpinner />}
          {attendance.status === 'data' && (
            <DataTable
              customStyles={tableCustomStyles}
              // className="data-table"
              noHeader
              highlightOnHover
              dense={true}
              responsive={true}
              data={attendance.data}
              columns={tableColumn(selectedMonth, selectedYear)}
            />
          )}
        </section>
      )}
    </AttendanceViewWrapper>
  );
};

export const AttendanceViewWrapper = styled.div`
  padding-right: 20px;

  .page-table {
    /* width: 80%; */
  }

  .page-tabs {
    margin: 16px 0;
    display: flex;
    justify-content: space-evenly;
    .grade-select-field {
      min-width: 200px;
    }
  }

  .section-wrapper {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
`;

export default AttendanceView;
